// extracted by mini-css-extract-plugin
export default {"main":"DateSection_main__2eIip","header":"DateSection_header__YbXZb","removeBut":"DateSection_removeBut__QkN7w"};